import React from 'react';
import {Container,Row,Col,Button,Form,Alert} from 'react-bootstrap';
import API from '../API.js'

export default class Login extends React.Component {

    constructor(props){
      super(props)
      this.state = {
        username:"",
        password:"",
        showError:false
      }
    }
  
    didUpdateUsername(event){
      this.setState({username:event.target.value})
    }
  
    didUpdatePassword(event){
      this.setState({password:event.target.value})
    }
  
    didPressOk(){
      this.setState({showError:false, errorMessage:""})
    }
  
    didPressSubmit(){
      // Clear Error Message
      this.setState({showError:false, errorMessage:""})

      API.login(this.state.username, this.state.password).then(response => {
        // On succesful login, redirect to sign in
        this.props.sessionDidUpdate(true, () => { 
          // find out why history.push doesn't rerender, probably has to do with react router (doesn't seem to be an issue anymore)
          //window.location = "/"  
          this.props.history.push("/")
        })
      }, error => {
        if(error && !error.response)
          this.setState({showError:true, errorMessage:"Login Failed - Server cannot be reached. Please check your internet connection, or server status."})
        else {
          this.setState({showError:true, errorMessage:"Login Failed - Username or password is incorrect."})
        }        
      })
    }
  
    render(){
      const ErrorAlert = props => {
        if(props.showError){
          return (
            <Row>
              <Col xs={6} style={{margin:"auto", marginTop:35}}>
                <Alert data-testid="close" key={0} variant={"danger"} onClose={this.didPressOk.bind(this)} dismissible>
                  {props.message}
                </Alert>
            </Col>
          </Row>
          )
        } else return null
      } 

      return (
        <Container fluid>
          <ErrorAlert showError={this.state.showError} message={this.state.errorMessage}/>
          <Row>
            <Col xs={6} style={{margin:"auto"}}>
              <h3 data-testid="title" style={{paddingTop:10, paddingBottom:10}}>Login Required</h3>
              <Form>
                <Form.Group controlId="formBasicEmail">
                  <Form.Label>Username</Form.Label>
                  <Form.Control type="text" placeholder="Enter username" onChange={this.didUpdateUsername.bind(this)} />
                </Form.Group>
  
                <Form.Group controlId="formBasicPassword">
                  <Form.Label>Password</Form.Label>
                  <Form.Control type="password" placeholder="Password" onChange={this.didUpdatePassword.bind(this)}/>
                </Form.Group>
                <Button variant="primary" onClick={this.didPressSubmit.bind(this)}>
                  Login
                </Button>
              </Form>
            </Col>
          </Row>
        </Container>
      )
    }
  }